import { Component, OnInit } from '@angular/core';
import { CompletionService } from 'src/app/services/completion.service';

@Component({
  selector: 'app-close',
  templateUrl: './close.component.html',
  styleUrls: ['./close.component.scss'],
})
export class CloseComponent implements OnInit {
  hidden = true;

  constructor(private completionService: CompletionService) {}

  ngOnInit() {
    if (this.inIframe()) {
      this.hidden = false;
    }
  }

  inIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  close() {
    this.completionService.terminate();
  }
}
